/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

export default function Loader({width = '20px', height = '20px'}) {
  return (
    // <div id="preloader">
      // <div id="status">
        <div className="spinner-chase" style={{width: width, height: height}}>
          <div className="chase-dot"/>
          <div className="chase-dot"/>
          <div className="chase-dot"/>
          <div className="chase-dot"/>
          <div className="chase-dot"/>
          <div className="chase-dot"/>
        {/* </div> */}
      {/* </div> */}
    </div> 
  )
}
